export default "__VITE_ASSET__BharWRTg__"